import { createEmptyEngineTelemetrySnapshot } from '@sorrem/engine';
import type { UIGameState } from '@sorrem-client/types';
import { createEmptyEssencePool } from '@sorrem/shared';

/** Max essence shown before (or when a payload lacks) the host's real pool. */
export const FALLBACK_MAX_ESSENCE = 100;

/** Party colors: the local player, and every other member of the party. */
export const LOCAL_PLAYER_COLOR = '#42A5F5';
export const PARTY_MEMBER_COLOR = '#66BB6A';

/**
 * The UI game state before the game has reported anything. Kept free of
 * React so the game runtime (which may run in a worker) can build its own
 * copy of the state from the same starting point as the page's bridge.
 */
export const DEFAULT_UI_GAME_STATE: UIGameState = {
    player: {
        name: '...',
        readiness: 1,
        essence: FALLBACK_MAX_ESSENCE,
        maxEssence: FALLBACK_MAX_ESSENCE,
        melee: 10,
        range: 10,
        dodge: 10,
        speed: 10,
        resistance: 10,
        color: LOCAL_PLAYER_COLOR,
        status: 'normal',
        essencePool: createEmptyEssencePool(),
        bankedEssencePool: createEmptyEssencePool(),
        maxCarryCapacity: 15,
        carriedItems: [],
        skills: [],
        // An empty slot is undefined: there is no placeholder item.
        equipped: {
            weapons: [null, null],
            armor: null,
            miscellaneous: [null, null, null, null],
        },
    },
    party: [],
    crucibleSessionState: null,
    telemetry: createEmptyEngineTelemetrySnapshot(),
    playerMapPos: { col: 0, row: 0 },
    gameTimeSec: 0,
    loadingProgress: null,
    runResult: null,
    notices: [],
    runHint: null,
    combatLog: [],
    selectedEntityInfo: null,
    isConnectionLost: false,
    fatalError: null,
    targetEssence: null,
    commission: null,
    fallen: null,
    expelled: null,
    coalescences: [],
    crystalUse: null,
    crystalEffects: [],
    miniMap: { knownAreaIds: [], allies: [], enemies: [], heart: null, essenceOrbs: [], selfFacing: { x: 0, y: 1 } },
    abilityCooldowns: {},
    abilityHold: null,
    debugOverlaySettings: {
        telemetryEnabled: false,
        entityInfoEnabled: false,
    },
};
